module.exports = __webpack_public_path__ + "img/counters-for-the-poor-gold.20611b37.png";